var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.2381 12.8319C25.2381 5.86622 19.5848 0.212891 12.619 0.212891C5.65333 0.212891 0 5.86622 0 12.8319C0 18.9396 4.34095 24.025 10.0952 25.1986V16.6177H7.57143V12.8319H10.0952V9.67718C10.0952 7.2417 12.0764 5.26051 14.5119 5.26051H17.6667V9.04622H15.1429C14.4488 9.04622 13.881 9.61408 13.881 10.3081V12.8319H17.6667V16.6177H13.881V25.3879C20.2536 24.7569 25.2381 19.3812 25.2381 12.8319Z",
    fill: "#C7D0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.fd578055a4194eb42de8b6579988cdc5.svg";
export { ForwardRef as ReactComponent };